import { Button } from "antd";
import React from "react";
import "./style.less";

const IconButton = ({ ...restProps }) => {
  return (
    <div className="ph_icon_btn ">
      <Button size="large" className="all_buttons" {...restProps} />
    </div>
  );
};

export default IconButton;
